import { useQuery } from 'react-query'

import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { ExternalBankAccount } from '@webapp/platform/banking/entities/ExternalBankAccount'
import { externalBankAccountQueryConfig } from '@webapp/platform/banking/query-configs/externalBankAccount'

type UseQueryExternalBankAccountsReturn = {
  externalBankAccounts: ExternalBankAccount[]
  isFetching: boolean
}

export const useQueryExternalBankAccounts = ({
  params,
  onError,
  enabled = true,
}: {
  params?: RepoFilterParams
  onError: () => void
  enabled?: boolean
}): UseQueryExternalBankAccountsReturn => {
  const { data, isFetching } = useQuery({
    ...externalBankAccountQueryConfig.getExternalBankAccounts(params),
    enabled,
    onError,
  })

  const externalBankAccounts = data?.data ?? []

  return {
    externalBankAccounts: externalBankAccounts.map(
      (account) => new ExternalBankAccount(account)
    ),
    isFetching,
  }
}
